<p-chart
  type="line"
  [data]="data"
  [options]="options"
  [height]="'350px'"
  [responsive]="true"
  class="h-[30rem]"
/>
